import AOS from 'aos';
/*import {
	Fancybox,
	Carousel,
	Panzoom
} from "@fancyapps/ui"; */
/*import {
	Fancybox
} from "@fancyapps/ui";*/
import Swiper from 'swiper/bundle';
exports.swiper = Swiper;

import Sticky from 'sticky-js';
var sticky = new Sticky('[data-sticky]', {});
window.sticky = sticky;

import Autocomplete from 'bootstrap5-autocomplete';

jQuery(function ($) {
	$(document).on('change', 'input[name="category"]', function () {
		$(this).closest('form').trigger('submit');
	})

	$('#filter-form').on('submit', function (event) {
		event.preventDefault();
		var formData = $(this).serialize();

		$.ajax({
			url: cinicoAjax.ajaxurl, // The WordPress AJAX handler
			data: formData,
			dataType: 'json',
			type: 'POST',
			beforeSend: function () {
				$('#cinico_posts_wrap').addClass('loading');
			},
			success: function (data) {
				// when filter applied:
				// set the current page to 1
				cinicoAjax.current_page = 1;

				// set the new query parameters
				cinicoAjax.posts = data.posts;

				// set the new max page parameter
				cinicoAjax.max_page = data.max_page;

				$('#cinico_posts_wrap').removeClass('loading').html(data.content);
				// hide load more button, if there are not enough posts for the second page
				if (data.max_page < 2) {
					$('#cinico_loadmore').hide();
				} else {
					$('#cinico_loadmore').show();
				}
			},
			error: function (xhr, status, error) {
				$('#cinico_posts_wrap').html('<p>Error occurred. Please try again later.</p>');
				console.log(xhr.responseText);
			}
		});
	});

	/*
	 * Load More
	 */
	$('#cinico_loadmore').click(function () {
		$.ajax({
			url: cinicoAjax.ajaxurl, // AJAX handler
			data: {
				'action': 'loadmorebutton', // the parameter for admin-ajax.php
				'query': cinicoAjax.posts, // loop parameters passed by wp_localize_script()
				'page': cinicoAjax.current_page // current page
			},
			type: 'POST',
			beforeSend: function (xhr) {
				$('#cinico_loadmore').text('Loading...'); // some type of preloader
			},
			success: function (posts) {
				if (posts) {
					console.log(posts);
					$('#cinico_loadmore').text('More posts');
					$('#cinico_posts_wrap').append(posts); // insert new posts
					cinicoAjax.current_page++;

					if (cinicoAjax.current_page == cinicoAjax.max_page)
						$('#cinico_loadmore').hide(); // if last page, HIDE the button
				} else {
					$('#cinico_loadmore').hide(); // if no data, HIDE the button as well
				}
			}
		});
		return false;
	});
});

document.addEventListener('DOMContentLoaded', function () {
	Autocomplete.init(
		'#faq-search-input', {
		server: cinicoAjax.ajaxurl,
		serverParams: {
			action: 'search_ajax',
			nonce: cinicoAjax.ajax_nonce,
		},
		liveServer: true,
		fullWidth: true,
		debounceTime: 2,
		notFoundMessage: 'Nothing found',
		labelField: 'title',
		valueField: 'title',
		searchFields: ['title', 'content'],
		autoselectFirst: false
	});

	AOS.init({
		once: true,
		duration: 800, // values from 0 to 3000, with step 50ms
		easing: 'ease-in-out',
		initClassName: false,
		//animatedClassName: 'animated',
	});

	const claimsTabs = document.getElementById('file-a-claim');
	if (claimsTabs) {
		// Get all tab triggers
		const tabTriggers = claimsTabs.querySelectorAll('[data-bs-toggle="tab"]');

		tabTriggers.forEach(function (trigger) {
			const tab = new cinico.Tab(trigger);
			// This will deactivate the tab
			trigger.classList.remove('active');
			trigger.setAttribute('aria-selected', 'false');
		});

		// Hide all tab panes
		claimsTabs.querySelectorAll('.tab-pane').forEach(function (pane) {
			pane.classList.remove('show', 'active');
		});
	}
});